import type ISchoolPeriodUserRepository from '@/core/domain/school/user/ISchoolPeriodUserRepository.ts'

export class DeleteSchoolPeriodUserUseCase {
  private readonly schoolPeriodUserRepository: ISchoolPeriodUserRepository

  constructor(schoolPeriodUserRepository: ISchoolPeriodUserRepository) {
    this.schoolPeriodUserRepository = schoolPeriodUserRepository
  }

  async execute(schoolId: number, schoolPeriodId: number, identifier: string) {
    return await this.schoolPeriodUserRepository.deleteSchoolPeriodUser(
      schoolId,
      schoolPeriodId,
      identifier
    )
  }
}
